import {
  RESET_SCRIPTS,
  RESET_SCRIPT,
  RESET_ERROR,
  GET_SCRIPTS,
  SET_SCRIPTS,
  API_ERROR,
  GET_SCRIPT,
  SET_SCRIPT,
  CREATE_SCRIPT,
  CREATE_SCRIPT_SUCCESS,
  EDIT_SCRIPT,
  EDIT_SCRIPT_SUCCESS,
  DELETE_SCRIPT,
  DELETE_SCRIPT_SUCCESS,
} from "./actionTypes";

export const resetScripts = () => {
  return {
    type: RESET_SCRIPTS,
    payload: {},
  };
};

export const resetScript = () => {
  return {
    type: RESET_SCRIPT,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getScripts = (page, qnt, name, skillId) => {
  return {
    type: GET_SCRIPTS,
    payload: { page, qnt, name, skillId },
  };
};

export const setScripts = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_SCRIPTS,
    payload: { ...data, paging },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createScript = (newScriptValues) => {
  return {
    type: CREATE_SCRIPT,
    payload: { newScriptValues },
  };
};
export const createScriptSuccess = (message) => {
  return {
    type: CREATE_SCRIPT_SUCCESS,
    payload: { message },
  };
};

export const getScript = (idScript, isForm) => {
  return {
    type: GET_SCRIPT,
    payload: { idScript, isForm },
  };
};
export const setScript = (data) => {
  return {
    type: SET_SCRIPT,
    payload: { data },
  };
};

export const editScript = (
  idScript,
  newScriptValues
) => {
  return {
    type: EDIT_SCRIPT,
    payload: { idScript, newScriptValues },
  };
};
export const editScriptSuccess = (message) => {
  return {
    type: EDIT_SCRIPT_SUCCESS,
    payload: { message },
  };
};

export const deleteScript = (idScript) => {
  return {
    type: DELETE_SCRIPT,
    payload: { idScript },
  };
};
export const deleteScriptSuccess = (message) => {
  return {
    type: DELETE_SCRIPT_SUCCESS,
    payload: { message },
  };
};
